import React from "react";
import { toNumber } from "lodash-es";
import { formatCentsAsDollars, parseCurrencyToCents } from "../../../util/formatters";

export const PharmacyPrimaryBenefits = ({ biInfo, coveredChargesEnabled, noMoopProvided = false }) => {
  return (
    <>
      {biInfo.productBenefits.map((benefits, index) => (
        <React.Fragment key={index}>
          {benefits.products.map((product) => (
            <React.Fragment key={product.productName}>
              <h3 className="text-dark fw-bold mb-3">{product.productName}</h3>
              {product.procedureCodes.map((procedureCode, codeIndex) => (
                <li
                  className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2"
                  key={`product${index + 1}-${procedureCode.code}-${codeIndex}`}
                  id={`product${index + 1}-${procedureCode.code}-${codeIndex}`}
                >
                  <h5 className="text-muted fw-semibold">
                    {procedureCode.code} ( {procedureCode.cptCodeCost}) x {procedureCode.multiplier}
                  </h5>

                  <h5 className="text-dark fw-bold">{calculateTotalCptCost(procedureCode.cptCodeCost, procedureCode.multiplier)}</h5>
                </li>
              ))}
            </React.Fragment>
          ))}
          {coveredChargesEnabled && (
            <>
              <li
                className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2"
                id={`product${index + 1}-patient-responsibility-covered`}
              >
                <h5 className="text-muted fw-semibold">Total Covered Charges</h5>
                <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.estimated_patient_responsibility_covered)}</h5>
              </li>

              <li
                className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2"
                id={`product${index + 1}-patient-responsibility-noncovered`}
              >
                <h5 className="text-muted fw-semibold">Total Non Covered Charges</h5>
                <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.estimated_patient_responsibility_noncovered)}</h5>
              </li>
            </>
          )}
          <li
            className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2"
            id={`product${index + 1}-deductible-remaining`}
          >
            <h5 className="text-muted fw-semibold">Current Remaining Deductible</h5>
            <h5 className="text-dark fw-bold">{benefits.deductible_remaining}</h5>
          </li>

          <li className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2" id={`product${index + 1}-total-deductible`}>
            <h5 className="text-muted fw-semibold">Total Deductible</h5>
            <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.deductible_cents)}</h5>
          </li>

          <li className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2" id={`product${index + 1}-moop`}>
            <h5 className="text-muted fw-semibold">Current Max Out of Pocket</h5>
            <h5 className="text-dark fw-bold">{noMoopProvided || benefits.moop_remaining == null ? "NA" : benefits.moop_remaining}</h5>
          </li>

          <li className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2" id={`product${index + 1}-total-moop`}>
            <h5 className="text-muted fw-semibold">Total Max Out of Pocket</h5>
            <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.moop_cents)}</h5>
          </li>

          <li className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2" id={`product${index + 1}-coinsurance`}>
            <h5 className="text-muted fw-semibold">Coinsurance</h5>
            <h5 className="text-dark fw-bold">{benefits.coinsurance}</h5>
          </li>

          <li
            className="d-flex flex-row justify-content-between align-items-center mb-4 mx-2"
            id={`product${index + 1}-estimated-patient-responsibility`}
          >
            <h5 className="text-muted fw-semibold">Estimated Patient Responsibility</h5>
            <h5 className="text-dark fw-bold">{benefits.estimated_patient_responsibility}</h5>
          </li>
        </React.Fragment>
      ))}
    </>
  );
};

const calculateTotalCptCost = (cptCodeCost, multiplier) => {
  return formatCentsAsDollars(parseCurrencyToCents(cptCodeCost) * toNumber(multiplier) || 0);
};
